<template>
  <div class="page" v-loading="loading">
    <box fill>
			<plabel text="LSB Cycle Count">
        <el-button class="btn-t-edit" @click="printBtn()" v-authority="'BACK_MENU7_M17_B1'">打印</el-button>
        <el-button class="btn-t-edit" @click="getMainData()">刷新</el-button>
				</plabel>
      <!-- 展示 -->
      <div class="body_div" id="pdfDown">
				<!-- 直材 -->
				<div class="left_div">
					<el-row>
						<div class="title">Direct Material Cycle Count</div>
					</el-row>
					<el-row>
						<el-table :data="mainMap.leftTableItem" style="width: 100%;border: 1px solid;" border>
							<el-table-column align="center" prop="item" label="Item"></el-table-column>
							<el-table-column align="center" prop="planDate" label="Plan Date"></el-table-column>
							<el-table-column align="center" prop="endDate" label="End Date"></el-table-column>
							<el-table-column align="center" prop="status" label="Status"></el-table-column>
							<el-table-column align="center" prop="rate" label="Achieving rate"></el-table-column>
						</el-table>
						<div class="echarts-box" ref="echartsPieLeft"></div>
					</el-row>
					<el-row>
						<el-table :data="mainMap.leftTableMonth" style="width: 100%;border: 1px solid;margin-top:10px;" border>
							<el-table-column align="center" prop="Month" label="Month" width="80"></el-table-column>
							<el-table-column align="center" prop="Jan" label="Jan"></el-table-column>
							<el-table-column align="center" prop="Feb" label="Feb"></el-table-column>
							<el-table-column align="center" prop="Mar" label="Mar"></el-table-column>
							<el-table-column align="center" prop="Apr" label="Apr"></el-table-column>
							<el-table-column align="center" prop="May" label="May"></el-table-column>
							<el-table-column align="center" prop="Jun" label="Jun"></el-table-column>
							<el-table-column align="center" prop="Jul" label="Jul"></el-table-column>
							<el-table-column align="center" prop="Aug" label="Aug"></el-table-column>
							<el-table-column align="center" prop="Sep" label="Sep"></el-table-column>
							<el-table-column align="center" prop="Oct" label="Oct"></el-table-column>
							<el-table-column align="center" prop="Nov" label="Nov"></el-table-column>
							<el-table-column align="center" prop="Dec" label="Dec"></el-table-column>
						</el-table>
						<div class="echarts-box" ref="echartsBarLeft"></div>
					</el-row>
				</div>
				<!-- 间材 -->
				<div class="right_div">
					<el-row>
						<div class="title">Indirect Material Cycle Count</div>
					</el-row>
					<el-row>
						<el-table :data="mainMap.rightTableItem" style="width: 100%;border: 1px solid;" border>
							<el-table-column align="center" prop="item" label="Item"></el-table-column>
							<el-table-column align="center" prop="planDate" label="Plan Date"></el-table-column>
							<el-table-column align="center" prop="endDate" label="End Date"></el-table-column>
							<el-table-column align="center" prop="status" label="Status"></el-table-column>
							<el-table-column align="center" prop="rate" label="Achieving rate"></el-table-column>
						</el-table>
						<div class="echarts-box" ref="echartsPieRight"></div>
					</el-row>
					<el-row>
						<el-table :data="mainMap.rightTableMonth" style="width: 100%;border: 1px solid;margin-top:10px;" border>
							<el-table-column align="center" prop="Month" label="Month" width="80"></el-table-column>
							<el-table-column align="center" prop="Jan" label="Jan"></el-table-column>
							<el-table-column align="center" prop="Feb" label="Feb"></el-table-column>
							<el-table-column align="center" prop="Mar" label="Mar"></el-table-column>
							<el-table-column align="center" prop="Apr" label="Apr"></el-table-column>
							<el-table-column align="center" prop="May" label="May"></el-table-column>
							<el-table-column align="center" prop="Jun" label="Jun"></el-table-column>
							<el-table-column align="center" prop="Jul" label="Jul"></el-table-column>
							<el-table-column align="center" prop="Aug" label="Aug"></el-table-column>
							<el-table-column align="center" prop="Sep" label="Sep"></el-table-column>
							<el-table-column align="center" prop="Oct" label="Oct"></el-table-column>
							<el-table-column align="center" prop="Nov" label="Nov"></el-table-column>
							<el-table-column align="center" prop="Dec" label="Dec"></el-table-column>
						</el-table>
						<div class="echarts-box" ref="echartsBarRight"></div>
					</el-row>
				</div>
      </div>
    </box>
  </div>
</template>
<script>
import * as echarts from "echarts"; // 导图全局 echarts
export default {
  name: "ReportLSBCycleCount",
  data() {
    return {
      headerCellStyle: () => {
        return "background-color: #1f5cec";
      },
      form: {},
      //主数据
      mainData: [],
			mainMap: {},
			loading: true, //加载中
    };
  },
  watch: {},
	mounted() {},

  methods: {
		printBtn(){
			this.$nextTick(() => {this.getPdf(document.querySelector("#pdfDown"),"LSB Cycle Count报表");})
		},
    //获取数据
    getMainData() {
			this.loading = true;
      this.$http
        .request({
          url: "/api/reportForms/CycleCountReport",
          method: "GET",
          params: {},
        })
        .then((resp) => {
					this.loading = false;
          if (resp.status == 100) {
						this.mainMap = resp.data || {};

						this.setPieChartLeft(this.mainMap.leftPie);
						this.setPieChartRight(this.mainMap.rightPie);
						this.setBarChartLeft(this.mainMap.leftBar);
						this.setBarChartRight(this.mainMap.righBar);
          } else {
						this.$message({
							message: resp.message,
							type: "error",
						});
					}
        })
        .catch((error) => {
					this.loading = false;
          this.$message({
						message: "操作失败"+error,
						type: "error",
          });
        });
    },

		setPieChartLeft(data) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs.echartsPieLeft);
    		var optionChart = {
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b} : {c} ({d}%)",
					},
					legend: {
						orient: "horizontal",
						type: "scroll",
						bottom: "1%"
					},
					series: [{
						name: "Direct Material",
						type: "pie",
						radius: "50%",
						data: data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
						label: {
							show: true,
							position: 'inside',
							formatter: '{d}%',
						}
					}],
				}
				myChart.setOption(optionChart);
      });
		},
		setPieChartRight(data) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs.echartsPieRight);
    		var optionChart = {
					tooltip: {
						trigger: "item",
						formatter: "{a} <br/>{b} : {c} ({d}%)",
					},
					legend: {
						orient: "horizontal",
						type: "scroll",
						bottom: "1%"
					},
					series: [{
						name: "Direct Material",
						type: "pie",
						radius: "50%",
						data: data,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: "rgba(0, 0, 0, 0.5)",
							},
						},
						label: {
							show: true,
							position: 'inside',
							formatter: '{d}%',
						}
					}],
				}
				myChart.setOption(optionChart);
      });
		},
		
		setBarChartLeft(data) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs.echartsBarLeft);
    		var optionChart = {
					title: {
						text: 'Direct Material',
						left: 'center',
						top: 10
					},
					tooltip: {
						trigger: 'axis',
						formatter: '{b0}: {c0}%'
					},
					legend: {
						data: ['Variation'],
						orient: 'horizontal',
						type: 'scroll',
						bottom: '1'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '30',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
					},
					yAxis: {
						name: '%',
						type: 'value'
					},
					series: data
				};
				myChart.setOption(optionChart);
			});
		},
		setBarChartRight(data) {
    	this.$nextTick(() => {
    		var myChart = echarts.init(this.$refs.echartsBarRight);
    		var optionChart = {
					title: {
						text: 'Indirect Material',
						left: "center",
						top: 10
					},
					tooltip: {
						trigger: 'axis',
						formatter: '{b0}: {c0}%'
					},
					legend: {
						data: ['Variation'],
						orient: 'horizontal',
						type: 'scroll',
						bottom: '1'
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '30',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						data: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
					},
					yAxis: {
						name: '%',
						type: 'value'
					},
					series: data
				};
				myChart.setOption(optionChart);
			});
		},
  },
  activated() {
    /* 获取首页的数据 */
		this.getMainData();
  },
};
</script>

<style scoped>
.body_div {
	margin: 5px 10px;
}
.body_div .title {
  text-align: center;
	font-size: 20px;
	line-height: 40px;
	height: 40px;
  background: #dddddd;
}
.left_div {
  width: 49%;
  float: left;
}
.right_div {
  width: 50%;
  float: left;
	margin-left: 1%;
}
.echarts-box {
	min-height: 200px;
	border-bottom: 1px solid;
	border-left: 1px solid;
	border-right: 1px solid;
}
</style>